import {formatDate} from 'helpers';
import moment from 'moment';
import {useState} from "react";
import truncate from "truncate";
import UpdateTask from "views/tasks/Update";
import ShowTask from "views/tasks/Show"
import useDropdown from "hooks/useDropdown";
import FeatherIcon from "feather-icons-react";

export default function TaskRow({task}) {

  const [dropdownIsOpen, toggleDropdown] = useDropdown()
  const [showIsOpen, setShowIsOpen] = useState(false)
  const [editIsOpen, setEditIsOpen] = useState(false)

  return(
    <tr style={{
        backgroundColor: moment(task.creation_date).isAfter(moment().endOf('month')) ? 'aliceblue' : '#fff'
      }}>
      <td><a href="#" onClick={()=> setShowIsOpen(true)}>{task.order}</a></td>
      <td><a href="#" onClick={()=> setShowIsOpen(true)}>{formatDate(task.creation_date)}</a></td>
      <td dir="auto">{truncate(task.title, 30)}</td>
      <td dir="auto"><a href="#" onClick={()=> setShowIsOpen(true)}>{truncate(task.content, 30)}</a></td>
      <td>{task.status}</td>
      <td className="is-end">
        <div>
          <div onClick={toggleDropdown}
               className={`dropdown is-spaced is-dots is-right dropdown-trigger is-pushed-mobile ${dropdownIsOpen && 'is-active'}`}>
            <div className="is-trigger" aria-haspopup="true">
              <FeatherIcon icon={'more-vertical'} />
            </div>
            <div className="dropdown-menu" role="menu">
              <div className="dropdown-content">
                <a href={"#"} className="dropdown-item is-media" onClick={() => setEditIsOpen(true)}>
                  <div className="icon">
                    <i className="lnil lnil-pencil-alt"/>
                  </div>
                  <div className="meta">
                    <span>Edit</span>
                    <span>Edit task details</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </td>
      <td>
        {showIsOpen && <ShowTask isOpen={showIsOpen} setIsOpen={setShowIsOpen} task={task}/>}
        {editIsOpen && <UpdateTask setIsOpen={setEditIsOpen} task={task}/>}
      </td>
    </tr>
  )
}
